export function basename(path: string) {
	/** Remove everything after ? */
	return path.toString().split(/[\\/]/).pop()?.split('?')[0];
}
